<template>
  <div class="register" v-loading="loading">
    <div class="register-title">ペット新規登録申請</div>
    <el-form ref="registerForm" :model="form" class="app-form" :rules="rules">
      <el-form-item label="ペットネーム" prop="petName">
        <el-input 
          v-model="form.petName" 
          autocomplete="off"
          placeholder="64桁以内" 
          maxlength="64"
        ></el-input>
      </el-form-item>
      <el-form-item label="誕生日" prop="tanjobi">
        <el-date-picker
          v-model="form.tanjobi"
          type="date"
          placeholder="1900/01/01"
          value-format="yyyyMMdd"
          format="yyyy/MM/dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="性別" prop="seibetsu">
        <el-radio v-model="form.seibetsu" label="0">オス</el-radio>
        <el-radio v-model="form.seibetsu" label="1">メス</el-radio>
        <el-radio v-model="form.seibetsu" label="2">不明</el-radio>
      </el-form-item>
      <el-form-item label="飼育開始予定日" prop="shiikuStartDate">
        <el-date-picker
          v-model="form.shiikuStartDate"
          type="date"
          placeholder="1900/01/01"
          value-format="yyyyMMdd"
          format="yyyy/MM/dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="種別" prop="dobutsuShubetsuId">
        <el-select v-model="form.dobutsuShubetsuId" @change="onShubetsuChange">
          <el-option v-for="item in shubetsuList" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="種類" prop="dobutsuShuruiId" v-if="showShuruiDropdown">
        <el-select v-model="form.dobutsuShuruiId" @change="onShuruiChange">
          <el-option v-for="item in shuruiList" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="犬種類" prop="mikkusuId" v-if="showMikkusuDropdown">
        <el-select v-model="form.mikkusuId">
          <el-option v-for="item in mikkusuList" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="その他入力" prop="mikkusu" v-if="showOtherInput">
        <el-input v-model="form.mikkusu" maxlength="128"></el-input>
      </el-form-item>
      <br>
      <table width="100%" class="commonTable">
        <tr>
          <th>顔写真 ※ペットの顔がわかるように、撮影してください</th>
        </tr>
        <tr v-if ="maeImgUrl">
          <td>
            <img :src="maeImgUrl" style="width: 100%;height: 200px;object-fit: contain;"/>
          </td>
        </tr>
        <tr>
          <td>
            <input type="file" ref="maeImg" accept="image/jpeg,image/png,image/webp">
          </td>
        </tr>
        <tr>
          <td>
            <el-button native-type="button" type="primary" plain @click="photoPreview($refs.maeImg, 'maeImgUrl');">写真プレビュー</el-button>
          </td>
        </tr>
      </table>
      <br>
      <table width="100%" class="commonTable">
        <tr>
          <th>全体写真 ※ペットの大きさがわかるように、撮影してください</th>
        </tr>
        <tr v-if ="zenshinImgUrl">
          <td>
            <img :src="zenshinImgUrl" style="width: 100%;height: 200px;object-fit: contain;"/>
          </td>
        </tr>
        <tr>
          <td>
            <input type="file" ref="zenshinImg" accept="image/jpeg,image/png,image/webp">
          </td>
        </tr>
        <tr>
          <td>
            <el-button native-type="button" type="primary" plain @click="photoPreview($refs.zenshinImg, 'zenshinImgUrl');">写真プレビュー</el-button>
          </td>
        </tr>
      </table>
      <br>
      <table width="100%" class="commonTable">
        <tr>
          <th>血統証(任意) ※内容が見えるように、撮影してください</th>
        </tr>
        <tr v-if="kettoshoImgUrl">
          <td>
            <img :src="kettoshoImgUrl" style="width: 100%;height: 200px;object-fit: contain;"/>
          </td>
        </tr>
        <tr>
          <td>
            <input type="file" ref="kettoshoImg" accept="image/jpeg,image/png,image/webp">
          </td>
        </tr>
        <tr>
          <td>
            <el-button native-type="button" type="primary" plain @click="photoPreview($refs.kettoshoImg, 'kettoshoImgUrl');">血統証プレビュー</el-button>
          </td>
        </tr>
      </table>
      <br>
      <el-form-item>
        <table width="100%">
          <tr>
            <td width="25%" v-if="!isReapplyStatus">
              <el-button type="primary" @click="onSubmit('0')">一時保存</el-button>
            </td>
            <td width="50%"></td>
            <td width="25%">
              <el-button type="warning" @click="onSubmit(isReapplyStatus ? '2' : '1')">
                {{ isReapplyStatus ? '再申請' : '申請' }}
              </el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import request from '@/utils/request';
import { validateFile } from '@/utils/tools';
import { getWfStatusLabel } from '@/utils/constant';
import imageCompression from 'browser-image-compression';

export default {
  name: 'Register',
  data() {
    return {
      loading: false, // ローディング中
      maeImgUrl: '',
      zenshinImgUrl: '',
      kettoshoImgUrl: '',
      wfStatus: '',
      form: {
        petSeq: this.$route.query.petSeq ? this.$route.query.petSeq : '',// 前画面で選択したペットのpetSeq
        petName: '',
        tanjobi: '',
        seibetsu: '0',
        shiikuStartDate: '',
        dobutsuShubetsuId: '', // 種別
        dobutsuShuruiId: '',   // 種類
        mikkusuId: '',         // 犬種類
        mikkusu: '',           // その他入力
      },
      masterList: [],          // マスタデータ
      rules: {
        petName: [
          { required: true, message: '必須です。', trigger: 'blur' },

        ],
      },
    };
  },
  created() {
    this.masterList = JSON.parse(sessionStorage.getItem('codeNameList'));
    // ペット情報取得
    if (this.form.petSeq) {
      this.loading = true;
      request('getTempPetInfo', this.form.petSeq).then((res) => {
        this.form.petName = res.petName;
        this.form.seibetsu = res.seibetsu;
        this.form.dobutsuShubetsuId = res.dobutsuShubetsuId;
        this.form.dobutsuShuruiId = res.dobutsuShuruiId;
        this.form.mikkusuId = res.mikkusuId;
        this.form.mikkusu = res.mikkusu;
        // this.maeImgUrl = res.maeImgUrl;
        // this.zenshinImgUrl = res.zenshinImgUrl;
        // this.kettoshoPdfUrl = res.kettoshoPdfUrl;
        this.wfStatus = res.wfStatus;
        if (res.tanjobi) 
          this.form.tanjobi = res.tanjobi;
        if (res.shiikuStartDate)
          this.form.shiikuStartDate = res.shiikuStartDate;
      }).finally(() => {
        this.loading = false;
      });   
    }
  },
  computed: {
    isReapplyStatus() {
      return getWfStatusLabel(this.wfStatus) === '差戻し';
    },
    // 種類プルダウン表示制御
    showShuruiDropdown() {
      const selectedShubetsu = this.shubetsuList.find(item => item.codeValue === this.form.dobutsuShubetsuId);
      return selectedShubetsu && selectedShubetsu.codeName !== 'その他';
    },
    // 犬種類プルダウン表示制御
    showMikkusuDropdown() {
      const selectedShubetsu = this.shubetsuList.find(item => item.codeValue === this.form.dobutsuShubetsuId);
      const selectedShurui = this.shuruiList.find(item => item.codeValue === this.form.dobutsuShuruiId);
      return (
        selectedShubetsu &&
        selectedShubetsu.codeName === '犬' &&
        selectedShurui &&
        selectedShurui.codeName !== 'その他'
      );
    },
    // その他入力テキストボックス表示制御
    showOtherInput() {
      // 選択されている種別と種類を取得
      const selectedShubetsu = this.shubetsuList.find(item => item.codeValue === this.form.dobutsuShubetsuId);
      const selectedShurui = this.shuruiList.find(item => item.codeValue === this.form.dobutsuShuruiId);
      // 種別が「その他」の場合、表示
      if (selectedShubetsu && selectedShubetsu.codeName === 'その他') return true;
      // 種類が「その他」の場合、表示
      if (selectedShurui && selectedShurui.codeName === 'その他') return true;
      return false;
    },
    // 種別プルダウンアイテム取得
    shubetsuList() {
      return this.masterList.filter(item => item.codeId === '3001');
    },
    // 種類プルダウンアイテム取得
    shuruiList() {
      if (!this.form.dobutsuShubetsuId) return [];
      return this.masterList.filter(item => item.codeId === '3003' && item.option01 === this.form.dobutsuShubetsuId);
    },
    // 犬種類プルダウンアイテム取得
    mikkusuList() {
      if (!this.form.dobutsuShuruiId) return [];
      return this.masterList.filter(item => item.codeId === '3002' && item.option01 === this.form.dobutsuShuruiId);
    }
  },
  methods: {
    // 承認ステータス名称取得
    getWfStatusLabel,
    photoPreview(fileInputRef, imgUrlField) {
      const imageFile = fileInputRef.files[0];
      // ファイルチェック（未選択、拡張子、サイズ）
      const msg = validateFile(imageFile, {
        allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
        maxSizeMB: 20
      });
      if (msg) {
        this.$message.error(msg);
        return;
      }
      // プレビュー画像生成
      const reader = new FileReader();
      reader.onload = (e) => {
        // this.$set(this.form, imgUrlField, e.target.result);
        this[imgUrlField] = e.target.result;
      };
      reader.readAsDataURL(imageFile);
    },
    toDate(ymd) {
      if (!ymd || ymd.length !== 8) return null;
      const y = Number(ymd.slice(0, 4));
      const m = Number(ymd.slice(4, 6)) - 1;
      const d = Number(ymd.slice(6, 8));
      const date = new Date(y, m, d);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    async onSubmit(wfStatusId) {
      try {
        // バリデーションチェック
        const isValid = await new Promise((resolve) => {
          this.$refs.registerForm.validate((valid) => {
            resolve(valid);
          });
        });
        if (!isValid) return false;
        // 日付関連チェック
        const tanjobiDate = this.toDate(this.form.tanjobi);
        const shiikuStartDate = this.toDate(this.form.shiikuStartDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (tanjobiDate && tanjobiDate > today) {
          this.$message.error('誕生日は今日以前の日付を入力してください。');
          return;
        }
        if (shiikuStartDate && tanjobiDate && shiikuStartDate < tanjobiDate) {
          this.$message.error('飼育開始予定日は誕生日以降の日付を入力してください。');
          return;
        }
        // 申請または再申請の場合、必須入力チェックを追加
        if (['1', '2'].includes(wfStatusId)) {
          if (!this.form.seibetsu) {
            this.$message.error('性別を選択してください。');
            return;
          }
          if (!this.form.dobutsuShubetsuId) {
            this.$message.error('種別を選択してください。');
            return;
          }
          if (this.showShuruiDropdown && !this.form.dobutsuShuruiId) {
            this.$message.error('種類を選択してください。');
            return;
          }
          if (this.showMikkusuDropdown && !this.form.mikkusuId) {
            this.$message.error('犬種類を入力してください。');
            return;
          } else if (this.showOtherInput && !this.form.mikkusu) {
            this.$message.error('その他入力を入力してください。');
            return;
          }
        }
        // フォームデータ作成
        const formData = new FormData();
        Object.entries(this.form)
          // 日付項目にnullや空文字を送信すると、Spring Bootのバリデーションで型変換エラー（typeMismatch）が発生し、
          // java.util.Date型に変換できずエラーになるため、送信を除外する。
          // ただし、送信しなくても該当項目は自動的にnullに更新されます（MyBatis-PlusやJPAの仕様）。
          .filter(([key, value]) => 
            !['tanjobi', 'shiikuStartDate'].includes(key) || value
          )
          .forEach(([key, value]) => {
            formData.append(key, value);
          });
        formData.append('shiikuStatus', '1');  
        formData.append('wfStatus', wfStatusId);
        const maeImgFile = this.$refs.maeImg.files[0];
        if (['1', '2'].includes(wfStatusId)) {
          const msg = validateFile(maeImgFile, {
            allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
            maxSizeMB: 20,
            msg: '顔写真'
          });
          if (msg) {
            this.$message.error(msg);
            return;
          }
          const compressOptions = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            initialQuality: 0.8
          };
          const compressedMaeImg = await imageCompression(maeImgFile, compressOptions);
          formData.append('maeImgFile', compressedMaeImg);
        }
        const zenshinImgFile = this.$refs.zenshinImg.files[0];
        if (['1', '2'].includes(wfStatusId)) {
          const msg = validateFile(zenshinImgFile, {
            allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
            maxSizeMB: 20,
            msg: '全体写真'
          });
          if (msg) {
            this.$message.error(msg);
            return;
          }
          const compressOptions = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            initialQuality: 0.8
          };
          const compressedZenshinImg = await imageCompression(zenshinImgFile, compressOptions);
          formData.append('zenshinImgFile', compressedZenshinImg);
        }
        const kettoshoImgFile = this.$refs.kettoshoImg.files[0];
        if (['1', '2'].includes(wfStatusId) && kettoshoImgFile) {
          const msg = validateFile(kettoshoImgFile, {
            allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
            maxSizeMB: 20,
            msg: '血統証'
          });
          if (msg) {
            this.$message.error(msg);
            return;
          }
          const compressOptions = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            initialQuality: 0.8
          };
          const compressedKettoshoImg = await imageCompression(kettoshoImgFile, compressOptions);
          formData.append('kettoshoImgFile', compressedKettoshoImg);
        }
        // フォームデータ送信
        this.loading = true;
        const res = await request('petRigest', formData);
        Message.success(res.msg);
        // 申請の場合はオーナー・マイページへ遷移
        if(['1', '2'].includes(wfStatusId)){
          this.goMyPets();
        }
        // 一次保存の場合は自画面へ遷移
        else {
          this.form.petSeq = res.petSeq;
          this.goPetRegist(this.form.petSeq);
        }
      } finally {
        this.loading = false;
      }
    },

    // オーナー・マイページへ遷移
    goMyPets() {
      this.$router.push({
        path: '/myPets',
      }).catch(() => {});
    },    
    // 自画面へ遷移
    goPetRegist(petSeq) {
      this.$router.push({
        path: '/petRegist',
        query: { petSeq }
      }).catch(() => {});
    },
    filterSpecialChars(value) {
      this.form.petName = value.replace(/[^\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff\u31f0-\u31ffa-zA-Z0-9]/g, '');
    },
    // 種別変更処理
    onShubetsuChange(value) {
      // 関連フィールドをクリア
      this.form.dobutsuShuruiId = '';
      this.form.mikkusuId = '';
      this.form.mikkusu = '';
    },
    // 種類変更処理
    onShuruiChange() {
      // 関連フィールドをクリア
      this.form.mikkusuId = '';
      this.form.mikkusu = '';
    }
  }
};
</script>

<style lang="less">
  html, body {
    overflow-x: hidden; // 横スクロールを防止
    width: 100%;        // 幅を100%に設定
  }
  .register {
    margin: 10px auto;
    max-width: 700px;
    .register-title {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 24px;
    }
    .register-subtitle {
      text-align: center;
      font-size: 18px;
      margin-bottom: 24px;
    }
    .register-docs {
      font-size: 16px;
      margin-bottom: 24px;
      line-height: 1.2;
    }
  }
  .commonTable {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 0;
    border: solid 2px #778ca3;
  }
  .commonTable th {
    padding: 10px;
    background: #e9faf9;
    border: solid 1px #778ca3;
    border-bottom: solid 2px #778ca3;
  }
  .commonTable td {
    padding: 10px;
    border-left: solid 1px #778ca3;
    text-align: left;
    vertical-align: top;
  }
  .commonTable tr {
    border-top: dashed 1px #778ca3;
  }
</style>
